{
  "title": "Настройки",
  "panel": {
    "createTitle": "Создать {{title}}",
    "updateTitle": "Обновить {{title}}",
    "createDescription": "Создать {{title}}.",
    "updateDescription": "Обновить {{title}}.",
    "removeTitle": "Удалить {{title}}",
    "removeText": "Вы уверены, что хотите удалить этот {{title}}? Это действие нельзя отменить.",
    "closePanel": "Закрыть панель",
    "remove": "Удалить",
    "test": "Тест",
    "ok": "OK!",
    "error": "ОШИБКА",
    "cancel": "Отмена",
    "create": "Создать",
    "save": "Сохранить"
  },
  "nav": {
    "application": "Приложение",
    "logs": "Логи",
    "indexers": "Индексаторы",
    "irc": "IRC",
    "feeds": "Фиды",
    "lists": "Списки",
    "clients": "Клиенты",
    "notifications": "Уведомления",
    "apiKeys": "API-ключи",
    "proxies": "Прокси",
    "releases": "Релизы",
    "account": "Аккаунт"
  },
  "application": {
    "title": "Приложение",
    "description": "Настройки приложения. Измените в config.toml и перезапустите для вступления в силу.",
    "host": "Хост",
    "port": "Порт",
    "baseUrl": "Базовый URL",
    "version": "Версия",
    "commit": "Коммит",
    "buildDate": "Дата сборки",
    "application": "Приложение",
    "configPath": "Путь конфигурации",
    "database": "База данных",
    "webuiDebugMode": "Режим отладки WebUI",
    "checkForUpdates": "Проверять обновления",
    "checkForUpdatesDescription": "Получать уведомления о новых обновлениях.",
    "theme": "Тема",
    "themeDescription": "Выберите светлую, тёмную или системную тему.",
    "languageDescription": "Выберите язык, используемый в WebUI.",
    "updateEnabled": "Теперь вы будете получать уведомления о новых обновлениях.",
    "updateDisabled": "Вы больше не будете получать уведомления о новых обновлениях.",
    "updateAvailable": "Доступно {{name}}!"
  },
  "account": {
    "title": "Аккаунт",
    "description": "Управление настройками аккаунта.",
    "required": "Обязательно",
    "passwordsDoNotMatch": "Пароли не совпадают!",
    "updateSuccess": "Пользователь успешно обновлён. Пожалуйста, войдите снова!",
    "updateError": "Ошибка при обновлении учётных данных. Вы указали правильный текущий пароль?",
    "changeCredentialsTitle": "Изменить учётные данные",
    "changeCredentialsDescription": "Имя пользователя и пароль можно изменить по отдельности или одновременно. Обратите внимание, что после изменения учётных данных вы будете перенаправлены на страницу входа.",
    "currentUsername": "Текущее имя пользователя",
    "newUsername": "Новое имя пользователя",
    "optional": "Необязательно",
    "currentPassword": "Текущий пароль",
    "requiredIfUpdatingCredentials": "Обязательно при обновлении учётных данных",
    "newPassword": "Новый пароль",
    "confirmNewPassword": "Подтвердите новый пароль",
    "save": "Сохранить",
    "identityProvider": "ваш провайдер идентификации",
    "oidcTitle": "Аккаунт OpenID Connect",
    "oidcDescription": "Учётными данными вашего аккаунта управляет провайдер OpenID Connect. Чтобы изменить имя пользователя, посетите страницу настроек вашего провайдера и войдите снова.",
    "authenticatedViaOidc": "Аутентифицирован через OpenID Connect"
  },
  "logsPage": {
    "title": "Логи",
    "description": "Настройте уровень логирования, ротацию по размеру и т.д. Ниже вы можете скачать старые файлы логов.",
    "chooseType": "Выберите тип",
    "updated": "Конфигурация успешно обновлена!",
    "path": "Путь",
    "setInConfig": "Задано в config.toml",
    "notSet": "Не задано!",
    "level": "Уровень",
    "logLevel": "Уровень логов",
    "maxSize": "Макс. размер",
    "maxBackups": "Макс. бэкапов"
  },
  "regexPlayground": {
    "title": "Песочница Regex",
    "description": "Песочница регулярных выражений. Экспериментируйте здесь со своими фильтрами. WIP.",
    "regexFilter": "Фильтр RegExp",
    "linesToMatch": "Строки для проверки",
    "matches": "Совпадения"
  },
  "apiKey": {
    "createTitle": "Создать API-ключ",
    "description": "Добавить новый API-ключ.",
    "created": "API-ключ {{name}} добавлен",
    "deleted": "API-ключ {{name}} удалён",
    "name": "Имя",
    "key": "Ключ",
    "required": "Обязательно",
    "closePanel": "Закрыть панель",
    "cancel": "Отмена",
    "create": "Создать",
    "listTitle": "API-ключи",
    "listDescription": "Управляйте вашими API-ключами autobrr здесь.",
    "addNew": "Добавить",
    "noItems": "Нет API-ключей",
    "createCta": "Создать API-ключ",
    "removeTitle": "Удалить API-ключ: {{name}}",
    "removeText": "Вы уверены, что хотите удалить этот API-ключ? Это действие нельзя отменить.",
    "deleteKey": "Удалить ключ"
  },
  "irc": {
    "listTitle": "IRC",
    "listDescription": "IRC сети и каналы. Нажмите на сеть, чтобы просмотреть статус каналов.",
    "addNew": "Добавить",
    "networkHealthy": "Сеть исправна",
    "networkUnhealthy": "Сеть неисправна",
    "networkDisabled": "Сеть отключена",
    "collapseTitle": "свернуть",
    "expandTitle": "развернуть",
    "collapse": "Свернуть",
    "expand": "Развернуть",
    "network": "Сеть",
    "noNetworks": "Нет сетей",
    "noNetworksSubtitle": "Обычно настраивается через Индексаторы",
    "addNewNetwork": "Добавить новую сеть",
    "toggleSuccess": "Сеть {{name}} успешно {{state}}.",
    "enabledState": "включена",
    "disabledState": "отключена",
    "connectedSince": "Подключено с: {{time}}",
    "tlsSecured": "Защищено с помощью TLS",
    "tlsInsecure": "Небезопасно, не использует TLS",
    "channel": "Канал",
    "monitoringSince": "Мониторится с",
    "lastAnnounce": "Последний анонс",
    "monitoring": "мониторится",
    "hide": "Скрыть",
    "view": "Просмотр",
    "networkDeleted": "Сеть {{name}} была удалена",
    "networkRestarted": "{{name}} успешно перезапущена",
    "removeNetworkTitle": "Удалить сеть: {{name}}",
    "removeNetworkText": "Вы уверены, что хотите удалить эту сеть? Это действие нельзя отменить.",
    "edit": "Изменить",
    "restart": "Перезапустить",
    "delete": "Удалить",
    "announceReprocessed": "Анонс отправлен на повторную обработку!",
    "reprocessAnnounce": "Повторно обработать анонс",
    "options": "Параметры",
    "scrollOnNewMessage": "Прокручивать вниз при новом сообщении",
    "title": "Сеть",
    "addWarning": "ДОБАВЛЯЙТЕ СЕТИ ЧЕРЕЗ ИНДЕКСАТОРЫ! ИСПОЛЬЗУЙТЕ ЭТО, ТОЛЬКО ЕСЛИ ВЫ УДАЛИЛИ СЕТИ",
    "added": "IRC сеть добавлена. Пожалуйста, подождите до 30 секунд, пока сеть не подключится.",
    "addFailed": "Не удалось добавить IRC сеть",
    "updated": "Сеть {{name}} успешно обновлена",
    "deleted": "Сеть {{name}} была удалена.",
    "required": "Обязательно",
    "name": "Имя",
    "enabled": "Включено",
    "server": "Сервер",
    "serverPlaceholder": "Адрес: Например, irc.server.net",
    "port": "Порт",
    "portPlaceholder": "Например, 6667",
    "tls": "TLS",
    "skipTls": "Пропустить проверку TLS (небезопасно)",
    "password": "Пароль",
    "passwordHelp": "Пароль сети",
    "passwordUpdateHelp": "Пароль сети, используется нечасто.",
    "nick": "Ник",
    "nickPlaceholderAdd": "ник бота",
    "nickPlaceholderUpdate": "ник",
    "authAccount": "Аккаунт аутентификации",
    "authAccountPlaceholder": "Аккаунт аутентификации",
    "authPassword": "Пароль аутентификации",
    "inviteCommand": "Команда приглашения",
    "channels": "Каналы",
    "channelsDesc": "Каналы для подключения.",
    "channelsUpdateDesc": "Каналы добавляются при настройке IRC индексаторов. Не изменяйте, если не знаете, что делаете.",
    "channelPassword": "Пароль канала",
    "remove": "Удалить",
    "noChannels": "Нет каналов!",
    "addChannel": "Добавить канал",
    "bouncer": "Bouncer (BNC)",
    "bouncerAddress": "Адрес bouncer'а",
    "bouncerAddressHelp": "Адрес: Например, bouncer.server.net:6697",
    "botMode": "Режим IRCv3 бота",
    "proxy": "Прокси",
    "proxyDesc": "Установить прокси для подключения к IRC серверу.",
    "selectProxy": "Выбрать прокси",
    "selectProxyPlaceholder": "Выберите прокси",
    "identification": "Идентификация",
    "identificationDesc": "Идентификация с помощью SASL или NickServ. Большинство сетей поддерживают SASL, но некоторые нет.",
    "mechanism": "Механизм",
    "account": "Аккаунт",
    "accountHelp": "Аккаунт NickServ / SASL. Для сгруппированных ников попробуйте основной.",
    "passwordSaslHelp": "Пароль NickServ / SASL.",
    "chooseType": "Выберите тип"
  },
  "releases": {
    "warningTitle": "Предупреждение:",
    "warningBody": "В этом разделе осуществляется управление удалением истории релизов. Задачи автоматической очистки запускаются по расписанию, в то время как ручное удаление позволяет провести немедленную единоразовую очистку. Обе операции удаляют данные навсегда и не могут быть отменены.",
    "olderThan": "Старше чем",
    "olderThanDesc": "Насколько старыми должны быть релизы до удаления (Обязательно как для автоматического, так и для ручного удаления)",
    "indexers": "Индексаторы",
    "indexersDesc": "Необязательный фильтр (если не выбран ни один, применяется ко всем индексаторам)",
    "releaseStatuses": "Статусы релизов",
    "releaseStatusesDesc": "Необязательный фильтр (если не выбран ни один, применяется ко всем статусам релизов)",
    "duplicateProfilesTitle": "Профили дубликатов релизов",
    "duplicateProfilesDesc": "Управление профилями дубликатов.",
    "cleanupJobsTitle": "Задачи очистки релизов",
    "cleanupJobsDesc": "Запланируйте автоматическую очистку старых релизов с настраиваемыми фильтрами.",
    "addNew": "Добавить",
    "edit": "Изменить",
    "enabled": "Включено",
    "name": "Имя",
    "lastRun": "Последний запуск",
    "nextRun": "Следующий запуск",
    "runNow": "Запустить сейчас",
    "delete": "Удалить",
    "never": "Никогда",
    "deleteReleaseHistory": "Удалить историю релизов",
    "deleteReleaseHistoryDesc": "Выберите критерии ниже, чтобы навсегда удалить записи истории релизов, которые старше выбранного возраста, и, по желанию, соответствуют выбранным индексаторам и статусам:",
    "removeReleases": "Удалить релизы",
    "invalidAge": "Пожалуйста, выберите корректный возраст.",
    "invalidAgeExample": "Пожалуйста, введите корректный возраст. Например, 6 месяцев или 1 год.",
    "allDeleted": "Все релизы на основе критериев были удалены.",
    "olderThanDeleted": "Релизы старше {{duration}} были удалены.",
    "allIndexers": "все индексаторы",
    "selectedIndexers": "выбранные индексаторы",
    "removeCleanupJobTitle": "Удалить задачу очистки: {{name}}",
    "removeCleanupJobText": "Вы уверены, что хотите удалить эту задачу очистки? Это действие нельзя отменить.",
    "cleanupJobToggled": "{{name}} {{state}}",
    "cleanupJobTriggered": "{{name}} запущена",
    "cleanupJobDeleted": "{{name}} удалена",
    "cleanupJobEnabled": "включена",
    "cleanupJobDisabled": "отключена",
    "duplicateFieldTitles": {
      "releaseName": "Имя релиза",
      "hash": "Нормализованный хеш имени релиза. Используйте вместе с Именем релиза для точного совпадения",
      "title": "Спарсенное название",
      "subTitle": "Спарсенный подзаголовок, например Имя эпизода",
      "group": "Релиз-группа",
      "year": "Год",
      "month": "Месяц",
      "day": "День",
      "source": "Источник",
      "resolution": "Разрешение",
      "codec": "Кодек",
      "container": "Контейнер",
      "dynamicRange": "Динамический диапазон (HDR, DV)",
      "audio": "Аудиоформаты",
      "season": "Номер сезона",
      "episode": "Номер эпизода",
      "website": "Вебсайт/Сервис",
      "proper": "Scene proper",
      "repack": "Scene repack",
      "edition": "Издание (например, Collectors Edition) и версия (например, Directors Cut)",
      "language": "Язык и Регион"
    },
    "noDuplicateProfiles": "Нет профилей дубликатов релизов",
    "addNewProfile": "Добавить новый профиль",
    "noCleanupJobs": "Нет задач очистки",
    "createCleanupSchedules": "Создать автоматические расписания очистки",
    "addNewJob": "Добавить новую задачу",
    "removeReleasesText": "Вы собираетесь {{scope}}.",
    "removeReleasesScopeAll": "удалить все записи истории релизов для {{indexers}}{{statuses}}",
    "removeReleasesScopeOlder": "навсегда удалить все записи истории релизов старше {{duration}} для {{indexers}}{{statuses}}",
    "removeReleasesStatuses": " и со следующими статусами релизов: {{statuses}}",
    "duration": {
      "allTime": "за всё время",
      "hour1": "1 час",
      "hours12": "12 часов",
      "day1": "1 день",
      "week1": "1 неделя",
      "month1": "1 месяц",
      "months3": "3 месяца",
      "months6": "6 месяцев",
      "year1": "1 год",
      "invalid": "Некорректная продолжительность"
    }
  },
  "forms": {
      "downloadClient": {
      "remove": "Удалить",
      "test": "Тест",
      "ok": "OK!",
      "error": "ОШИБКА",
      "cancel": "Отмена",
      "create": "Создать",
      "save": "Сохранить",
      "added": "Клиент добавлен",
      "addFailed": "Не удалось добавить клиента",
      "updated": "Клиент {{name}} успешно обновлён",
      "deleted": "Клиент {{name}} удалён.",
      "addTitle": "Добавить клиента",
      "addDescription": "Добавить клиент для загрузки.",
      "editTitle": "Редактировать клиента",
      "editDescription": "Редактировать настройки клиента загрузки.",
      "removeTitle": "Удалить клиент загрузки",
      "removeText": "Вы уверены, что хотите удалить этот клиент загрузки? Это действие нельзя отменить.",
      "closePanel": "Закрыть панель",
      "name": "Имя",
      "enabled": "Включено",
      "type": "Тип",
      "host": "Хост",
      "port": "Порт",
      "tls": "TLS",
      "skipTls": "Пропустить проверку TLS (небезопасно)",
      "username": "Имя пользователя",
      "password": "Пароль",
      "apiKey": "API-ключ",
      "authToken": "Токен авторизации",
      "basicAuth": "Базовая авторизация",
      "auth": "Авторизация",
      "authType": "Тип авторизации",
      "selectAuthType": "Выберите тип авторизации",
      "authTypeTooltip": "В большинстве случаев это Basic Auth, но некоторые провайдеры используют Digest Auth.",
      "hostHelpDeluge": "Например: client.domain.ltd, domain.ltd/client, domain.ltd:port",
      "hostHelpArr": "Полный url http(s)://domain.ltd и/или поддомен/подпапка",
      "hostHelpQbit": "Например: http(s)://client.domain.ltd, http(s)://domain.ltd/qbittorrent, http://domain.ltd:port",
      "hostHelpPorla": "Например: http(s)://client.domain.ltd, http(s)://domain.ltd/porla, http://domain.ltd:port",
      "hostHelpRTorrent": "Например: http(s)://client.domain.ltd/RPC2, http(s)://domain.ltd/client, http(s)://domain.ltd/RPC2",
      "hostHelpTransmission": "Например: http(s)://client.domain.ltd, http(s)://domain.ltd/transmission",
      "hostHelpSabnzbd": "Например: http://ip:port или https://url.com/sabnzbd",
      "hostHelpNzbget": "Например: http://localhost:6789",
      "daemonPort": "Порт демона",
      "webUiPortQbit": "Порт WebUI для qBittorrent",
      "transmissionPort": "Порт для Transmission",
      "sabnzbdPort": "Порт для SABnzbd",
      "guidesDeluge": "Смотрите руководства по подключению к Deluge в нашей документации.",
      "guidesArr": "Смотрите руководства по подключению к *arr приложениям в нашей документации.",
      "guidesQbit": "Смотрите руководства по подключению к qBittorrent в нашей документации.",
      "guidesRTorrent": "Смотрите руководства по подключению к rTorrent в нашей документации.",
      "guidesTransmission": "Смотрите руководства по подключению к Transmission в нашей документации.",
      "guidesSabnzbd": "Смотрите руководства по подключению к SABnzbd в нашей документации.",
      "dedicatedServers": "Выделенные серверы:",
      "sharedSeedboxProviders": "Общие сидбоксы:",
      "rulesTitle": "Правила",
      "rulesDescriptionBasic": "Управление максимальным числом загрузок.",
      "rulesDescriptionAdvanced": "Управление максимальным числом загрузок и т.д.",
      "maxActiveDownloads": "Макс. активных загрузок",
      "maxActiveDownloadsTooltip": "Ограничить количество активных загрузок (0 — без ограничений).",
      "seeRecommendations": "Смотрите рекомендации для различных типов серверов здесь:",
      "downloadClientTitle": "Клиент загрузки",
      "downloadClientDescription": "Переопределить клиент загрузки.",
      "clientName": "Имя клиента",
      "clientNameTooltip": "Укажите, какой клиент arr должен использовать по умолчанию.",
      "clientIdDeprecated": "ID клиента УСТАРЕЛО",
      "clientIdDeprecatedTooltip": "УСТАРЕЛО: Используйте Имя клиента.",
      "ignoreSlowTorrents": "Игнорировать медленные торренты",
      "ignoreCondition": "Условие игнорирования",
      "selectIgnoreCondition": "Выберите условие игнорирования",
      "ignoreConditionTooltip": "Выбор: учитывать или игнорировать макс. загрузки перед проверкой порогов.",
      "downloadSpeedThreshold": "Порог скорости скачивания",
      "uploadSpeedThreshold": "Порог скорости отдачи",
      "speedThresholdPlaceholder": "в КБ/с (KB/s)",
      "downloadSpeedThresholdHelp": "Если скачивание ниже порога, всё равно качать (КБ/с)",
      "uploadSpeedThresholdHelp": "Если отдача ниже порога, всё равно качать (КБ/с)"
    },
    "feed": {
      "title": "Фид",
      "updated": "Фид {{name}} успешно обновлён",
      "deleted": "Фид {{name}} удалён.",
      "testOk": "Тест {{name}} прошел успешно!",
      "name": "Имя",
      "type": "Тип",
      "enabled": "Включено",
      "warningTitle": "Внимание: Индексаторы могут забанить вас за маленький интервал!",
      "warningText": "Читайте правила индексатора.",
      "url": "URL",
      "torznabUrlHelp": "URL Torznab без дополнительных параметров.",
      "newznabUrlHelp": "URL Newznab без дополнительных параметров.",
      "rssUrlHelp": "URL RSS",
      "urlFormatTitle": "Prowlarr и Jackett имеют разные форматы:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "downloadType": "Тип загрузки",
      "apiKey": "API-ключ",
      "skipTls": "Пропустить проверку TLS (небезопасно)",
      "refreshInterval": "Интервал обновления",
      "refreshIntervalHelp": "Минуты. Рекомендуется 15-30.",
      "refreshTimeout": "Таймаут обновления",
      "refreshTimeoutHelp": "Секунды ожидания до отмены обновления.",
      "maxAge": "Макс. возраст",
      "maxAgeHelp": "Максимальный возраст в секундах (0 = без фильтра).",
      "cookie": "Cookie",
      "cookieHelp": "Редко используется",
      "categoriesTitle": "Категории",
      "categoriesDescription": "Получить и выбрать категории.",
      "fetch": "Получить",
      "fetching": "Получение",
      "refetch": "Получить снова",
      "fetchFailed": "Ошибка получения категорий",
      "noCategories": "Категории не найдены.",
      "fetchToSelect": "Получите категории для выбора."
    },
    "list": {
      "added": "Список добавлен!",
      "addFailed": "Не удалось добавить список",
      "updated": "Список {{name}} успешно обновлён",
      "deleted": "Список {{name}} удалён.",
      "name": "Имя",
      "type": "Тип",
      "enabled": "Включено",
      "filters": "Фильтры",
      "addTitle": "Добавить список",
      "updateTitle": "Обновить список",
      "description": "Автоматическое обновление фильтров из списков и приложений arr.",
      "closePanel": "Закрыть панель",
      "chooseType": "Выберите тип",
      "chooseClient": "Выберите клиента",
      "selectClient": "Выбрать клиента",
      "selectClientLabel": "Выбрать клиента",
      "filtersDescription": "Выберите фильтры для обновления в этом списке.",
      "cancel": "Отмена",
      "remove": "Удалить",
      "save": "Сохранить",
      "saving": "Сохранение..",
      "selectSomeItems": "Выбрать...",
      "allItemsSelected": "Все элементы выбраны",
      "selectAll": "Выбрать всё",
      "search": "Поиск",
      "noOptions": "Нет вариантов",
      "removeTitle": "Удалить {{name}}",
      "removeText": "Вы уверены, что хотите удалить {{name}}? Это действие нельзя отменить.",
      "required": "Обязательно",
      "settingsLegend": "Настройки",
      "source": "Источник",
      "sourceList": "Список-источник",
      "arrSourceDescription": "Обновление фильтров по названиям из Radarr, Sonarr, Lidarr, Readarr или Whisparr.",
      "traktSourceDescription": "Использовать список Trakt или один из встроенных списков autobrr.",
      "anilistSourceDescription": "Использовать список AniList или один из встроенных списков autobrr.",
      "plaintextSourceDescription": "Использовать текстовый список (по одному элементу на строку).",
      "steamSourceDescription": "Отслеживать списки желаемого Steam.",
      "metacriticSourceDescription": "Использовать список Metacritic или один из встроенных списков autobrr.",
      "mdblistSourceDescription": "Использовать список MDBList или один из встроенных списков autobrr.",
      "listUrl": "URL списка",
      "traktHelp": "Списки Trakt по умолчанию. Можно переопределить своими.",
      "traktApiKey": "API-ключ",
      "traktApiKeyHelp": "API-ключ Trakt. Необходим для приватных списков.",
      "matchRelease": "Сопоставление релизов",
      "matchReleaseDesc": "Использовать поле «Сопоставлять релизы». По умолчанию используется Фильмы/Сериалы.",
      "includeUnmonitored": "Включить неотслеживаемые",
      "includeUnmonitoredDesc": "По умолчанию фильтруются только отслеживаемые элементы.",
      "includeAlternateTitles": "Включить альтернативные названия",
      "includeAlternateTitlesDesc": "Включить альтернативные названия в фильтр.",
      "skipCleanSanitize": "Пропустить очистку и использовать список «как есть»",
      "skipCleanSanitizeDesc": "По умолчанию названия автоматически очищаются и проверяются.",
      "tagsIncluded": "Теги включены",
      "tagsExcluded": "Теги исключены",
      "metacriticHelp": "Списки Metacritic. Можно переопределить своими.",
      "mdblistHelp": "Списки MDBLists.com. Можно переопределить своими.",
      "includeYear": "Включить год",
      "includeYearDesc": "Включить год релиза в фильтр для фильмов. Пример: Movie?Title?2024*",
      "plaintextUrlHelp": "URL к текстовому файлу (по одному элементу на строку)",
      "plaintextUrlPlaceholder": "https://example.com/list.txt",
      "plaintextTooltip1": "Текстовые списки читаются как по HTTP, так и из локальных файлов.",
      "plaintextTooltipRemote": "Удалённый: https://service.com/file.txt",
      "plaintextTooltipLocal": "Локальный: file:///home/username/file.txt",
      "url": "URL",
      "steamUrlHelp": "URL списка желаемого Steam",
      "steamUrlPlaceholder": "https://store.steampowered.com/wishlist/id/USERNAME/wishlistdata"
    },
    "proxy": {
      "title": "Прокси",
      "addTitle": "Добавить прокси",
      "addDescription": "Добавить прокси для индексаторов или IRC.",
      "added": "Прокси добавлен!",
      "addFailed": "Не удалось добавить прокси",
      "updated": "Прокси {{name}} обновлён!",
      "updateFailed": "Не удалось обновить прокси",
      "deleted": "Прокси {{name}} удалён.",
      "name": "Имя",
      "closePanel": "Закрыть панель",
      "enabled": "Включено",
      "proxyType": "Тип прокси",
      "proxyTypeTooltip": "Тип прокси. Обычно SOCKS5.",
      "proxyTypeHelp": "Обычно SOCKS5",
      "addr": "Адрес",
      "addrHelp": "Адрес: scheme://ip:port или scheme://domain",
      "user": "Пользователь",
      "userHelp": "авторизация: имя пользователя",
      "pass": "Пароль",
      "passHelp": "авторизация: пароль",
      "test": "Тест",
      "cancel": "Отмена",
      "save": "Сохранить"
    },
    "apiKey": {
      "createTitle": "Создать API-ключ",
      "description": "Добавить новый API-ключ.",
      "created": "API-ключ {{name}} добавлен",
      "deleted": "API-ключ {{name}} удалён",
      "name": "Имя",
      "key": "Ключ",
      "required": "Обязательно",
      "closePanel": "Закрыть панель",
      "cancel": "Отмена",
      "create": "Создать",
      "listTitle": "API-ключи",
      "listDescription": "Управляйте своими API-ключами autobrr здесь.",
      "addNew": "Добавить",
      "noItems": "Нет API-ключей",
      "createCta": "Создать API-ключ",
      "removeTitle": "Удалить API-ключ: {{name}}",
      "removeText": "Вы уверены, что хотите удалить этот API-ключ? Это действие нельзя отменить.",
      "deleteKey": "Удалить ключ"
    },
    "notification": {
      "settings": "Настройки",
      "settingsDescDiscordPrefix": "Создайте ",
      "settingsDescDiscordSuffix": " на вашем сервере.",
      "discordWebhookIntegration": "интеграцию webhook",
      "settingsDescNotifiarr": "Включите интеграцию с autobrr и (необязательно) создайте новый API-ключ.",
      "settingsDescLunasea1": "LunaSea предлагает уведомления на всех устройствах, связанных с аккаунтом (User-Based), или на одном устройстве без аккаунта.",
      "settingsDescLunasea2Prefix": "Прочитайте ",
      "settingsDescLunasea2Suffix": ".",
      "lunaseaDocs": "документацию LunaSea",
      "settingsDescTelegramPrefix": "Узнайте, как ",
      "settingsDescTelegramSuffix": ".",
      "createBot": "создать бота",
      "settingsDescPushoverPrefix": "Зарегистрируйте новое ",
      "settingsDescPushoverSuffix": " и добавьте его API-токен сюда.",
      "pushoverApplication": "приложение",
      "eventSounds": "Звуки событий",
      "eventSoundsDesc": "Установить пользовательские звуки для каждого события",
      "settingsDescWebhook": "Отправлять JSON-payload autobrr на указанный webhook URL.",
      "added": "Уведомление добавлено!",
      "addFailed": "Не удалось добавить уведомление",
      "updated": "Уведомление {{name}} успешно обновлено",
      "deleted": "Уведомление {{name}} удалено.",
      "required": "Обязательно",
      "addTitle": "Добавить уведомления",
      "addDescription": "Запуск уведомлений при различных событиях.",
      "title": "Уведомление",
      "name": "Имя",
      "type": "Тип",
      "enabled": "Включено",
      "chooseType": "Выберите тип",
      "closePanel": "Закрыть панель",
      "globalEvents": "Глобальные события",
      "globalEventsDesc": "События по умолчанию, срабатывающие глобально. Их можно переопределить на уровне фильтра.",
      "perFilterEvents": "События фильтров",
      "perFilterEventsDesc": "Это уведомление используется в этих фильтрах.",
      "notUsedInFilters": "Не используется ни в одном фильтре",
      "muted": "Отключено",
      "test": "Тест",
      "cancel": "Отмена",
      "save": "Сохранить",
      "notificationsLegend": "Уведомления",
      "defaultTone": "По умолчанию (стандартный тон)",
      "webhookUrl": "Webhook URL",
      "discordWebhookPlaceholder": "https://discordapp.com/api/webhooks/xx/xx",
      "discordWebhookHelp": "URL вебхука канала Discord",
      "notifiarrApiKey": "API-ключ",
      "notifiarrApiKeyHelp": "API-ключ Notifiarr",
      "lunaseaWebhookPlaceholder": "https://notify.lunasea.app/v1/custom/user/TOKEN",
      "lunaseaWebhookHelp": "Webhook URL LunaSea",
      "botToken": "Токен бота",
      "botTokenHelp": "Токен бота",
      "chatId": "ID чата",
      "chatIdHelp": "ID чата",
      "messageThreadId": "ID ветки сообщений",
      "messageThreadIdHelp": "Ветка сообщений (topic) в Супергруппе",
      "telegramProxy": "Прокси API Telegram",
      "telegramProxyHelp": "Домен обратного прокси для api.telegram.org. Нужен только если ваша сеть блокирует API.",
      "telegramProxyPlaceholder": "http(s)://ip:port",
      "sender": "Отправитель",
      "senderHelp": "Пользовательское имя отправителя вверху уведомления",
      "senderPlaceholder": "autobrr",
      "apiToken": "API-токен",
      "apiTokenHelp": "API-токен",
      "userKey": "Ключ пользователя",
      "userKeyHelp": "Ключ пользователя",
      "priority": "Приоритет",
      "pushoverPriorityHelp": "-2, -1, 0 (по умолчанию), 1 или 2",
      "gotifyUrl": "Gotify URL",
      "gotifyUrlHelp": "Gotify URL (без /message)",
      "gotifyUrlPlaceholder": "https://some.gotify.server.com",
      "applicationToken": "Токен приложения",
      "applicationTokenHelp": "Токен приложения",
      "ntfyUrl": "NTFY URL",
      "ntfyUrlHelp": "NTFY URL",
      "ntfyUrlPlaceholder": "https://ntfy.sh/mytopic",
      "username": "Имя пользователя",
      "usernameHelp": "Имя пользователя",
      "password": "Пароль",
      "passwordHelp": "Пароль",
      "accessToken": "Токен доступа",
      "accessTokenHelp": "Токен доступа. Используйте его ИЛИ Имя пользователя + пароль",
      "ntfyPriorityHelp": "Макс 5, 4, 3 (по умолчанию), 2, 1 Мин",
      "url": "URL",
      "urlHelp": "URL",
      "shoutrrrDocsPrefix": "Смотрите документацию ",
      "shoutrrrServices": "Сервисы",
      "shoutrrrUrlPlaceholder": "smtp://username:password@host:port/?from=fromAddress&to=recipient1",
      "httpMethod": "HTTP-метод",
      "httpMethodDefault": "POST (по умолчанию)",
      "httpMethodTooltip": "HTTP-метод для webhook. По умолчанию POST.",
      "webhookPlaceholder": "https://example.com/webhook",
      "customHeaders": "Пользовательские заголовки",
      "customHeadersHelp": "Пары КЛЮЧ=значение через запятую",
      "customHeadersPlaceholder": "Authorization=Bearer token,X-Custom-Header=value"
    },
    "irc": {
      "listTitle": "IRC",
      "listDescription": "IRC-сети и каналы.",
      "addNew": "Добавить",
      "networkHealthy": "Сеть исправна",
      "networkUnhealthy": "Сеть неисправна",
      "networkDisabled": "Сеть отключена",
      "collapseTitle": "свернуть",
      "expandTitle": "развернуть",
      "collapse": "Свернуть",
      "expand": "Развернуть",
      "network": "Сеть",
      "noNetworks": "Нет сетей",
      "noNetworksSubtitle": "Обычно настраивается через Индексаторы",
      "addNewNetwork": "Добавить новую сеть",
      "toggleSuccess": "Сеть {{name}} успешно {{state}}.",
      "enabledState": "включена",
      "disabledState": "отключена",
      "connectedSince": "Подключено с: {{time}}",
      "tlsSecured": "Защищено через TLS",
      "tlsInsecure": "Небезопасно, не используется TLS",
      "channel": "Канал",
      "monitoringSince": "Мониторинг с",
      "lastAnnounce": "Последний анонс",
      "monitoring": "мониторинг",
      "hide": "Скрыть",
      "view": "Просмотр",
      "networkDeleted": "Сеть {{name}} удалена",
      "networkRestarted": "Сеть {{name}} успешно перезапущена",
      "removeNetworkTitle": "Удалить сеть: {{name}}",
      "removeNetworkText": "Вы уверены, что хотите удалить эту сеть? Это действие нельзя отменить.",
      "edit": "Редактировать",
      "restart": "Перезапустить",
      "delete": "Удалить",
      "announceReprocessed": "Анонс отправлен на повторную обработку!",
      "reprocessAnnounce": "Повторно обработать анонс",
      "options": "Опции",
      "scrollOnNewMessage": "Прокручивать вниз при новом сообщении",
      "title": "Сеть",
      "addWarning": "ДОБАВЛЯЙТЕ СЕТИ ЧЕРЕЗ ИНДЕКСАТОРЫ!",
      "added": "IRC-сеть добавлена.",
      "addFailed": "Не удалось добавить IRC-сеть",
      "updated": "Сеть {{name}} успешно обновлена",
      "deleted": "Сеть {{name}} удалена.",
      "required": "Обязательно",
      "name": "Имя",
      "enabled": "Включено",
      "server": "Сервер",
      "serverPlaceholder": "Адрес: Например, irc.server.net",
      "port": "Порт",
      "portPlaceholder": "Например, 6667",
      "tls": "TLS",
      "skipTls": "Пропустить проверку TLS (небезопасно)",
      "password": "Пароль",
      "passwordHelp": "Пароль сети",
      "passwordUpdateHelp": "Пароль сети, используется редко.",
      "nick": "Ник",
      "nickPlaceholderAdd": "ник бота",
      "nickPlaceholderUpdate": "ник",
      "authAccount": "Аккаунт авторизации",
      "authAccountPlaceholder": "Аккаунт авторизации",
      "authPassword": "Пароль авторизации",
      "inviteCommand": "Команда приглашения",
      "channels": "Каналы",
      "channelsDesc": "Каналы для входа.",
      "channelsUpdateDesc": "Каналы добавляются при настройке IRC-индексаторов.",
      "channelPassword": "Пароль канала",
      "remove": "Удалить",
      "noChannels": "Нет каналов!",
      "addChannel": "Добавить канал",
      "bouncer": "Bouncer (BNC)",
      "bouncerAddress": "Адрес Bouncer",
      "bouncerAddressHelp": "Адрес: Например, bouncer.server.net:6697",
      "botMode": "Режим бота IRCv3",
      "proxy": "Прокси",
      "proxyDesc": "Установите прокси для IRC.",
      "selectProxy": "Выберите прокси",
      "selectProxyPlaceholder": "Выберите прокси",
      "identification": "Идентификация",
      "identificationDesc": "Идентификация через SASL или NickServ.",
      "mechanism": "Механизм",
      "account": "Аккаунт",
      "accountHelp": "Аккаунт NickServ / SASL.",
      "passwordSaslHelp": "Пароль NickServ / SASL.",
      "chooseType": "Выберите тип"
    },
    "indexer": {
      "title": "Индексатор",
      "addTitle": "Добавить индексатор",
      "addDescription": "Добавить индексатор.",
      "added": "Индексатор добавлен",
      "addFailed": "Не удалось добавить индексатор",
      "updated": "Индексатор {{name}} успешно обновлён",
      "deleted": "Индексатор {{name}} удалён.",
      "indexer": "Индексатор",
      "chooseIndexer": "Выберите индексатор",
      "required": "Обязательно",
      "defaultValueValidation": "Значение по умолчанию, пожалуйста измените",
      "enabled": "Включено",
      "baseUrl": "Базовый URL",
      "baseUrlHelp": "Переопределите базовый URL, если он заблокирован вашим провайдером.",
      "cancel": "Отмена",
      "save": "Сохранить",
      "closePanel": "Закрыть панель",
      "ircTitle": "IRC",
      "ircDesc": "Сети и каналы настраиваются автоматически в фоновом режиме.",
      "torznabTitle": "Torznab",
      "torznabDesc": "Фид Torznab",
      "newznabTitle": "Newznab",
      "newznabDesc": "Фид Newznab",
      "rssTitle": "RSS",
      "rssDesc": "Фид RSS",
      "settingsIrcTitle": "IRC",
      "settingsIrcDesc": "Сети и каналы настраиваются автоматически в фоновом режиме.",
      "ircGuideTooltip": "Пожалуйста, прочитайте наше руководство по IRC, если вы с ним не знакомы.",
      "name": "Имя",
      "url": "URL",
      "torznabUrlHelp": "URL Torznab. Используйте только URL без дополнительных параметров.",
      "newznabUrlHelp": "URL Newznab. Используйте только URL без дополнительных параметров.",
      "urlFormatTitle": "У Prowlarr и Jackett разные форматы:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "apiKey": "API-ключ",
      "downloadType": "Тип загрузки",
      "downloadTypeTooltip": "Для некоторых фидов нужно принудительно включить Magnet.",
      "downloadTypeHelp": "Установите Torrent или Magnet в зависимости от индексатора.",
      "downloadTypeTooltip2": "Для некоторых фидов нужно принудительно включить Magnet.",
      "categoriesTitle": "Категории",
      "categoriesDescription": "Получить доступные категории и выбрать, какие включить.",
      "fetch": "Получить",
      "fetching": "Получение",
      "refetch": "Получить снова",
      "fetchFailed": "Не удалось получить категории",
      "fetchNeedsUrl": "Введите URL для получения категорий",
      "noCategories": "Категории не найдены.",
      "fetchToSelect": "Получите категории для выбора.",
      "testApi": "Тест API",
      "testApiSuccess": "Тест API прошел успешно!",
      "ok": "OK!",
      "error": "ОШИБКА",
      "externalIdentifier": "Внешний идентификатор",
      "externalIdentifierHelp": "Внешний идентификатор для ARR-приложений. Если используете Prowlarr: {{name}} (Prowlarr)",
      "externalIdentifierTooltip1": "Внешний идентификатор для использования с ARR, чтобы работали лимиты сидирования.",
      "externalIdentifierTooltip2": "Должно совпадать с именем индексатора в вашем ARR. Для Prowlarr это скорее всего \"{{name}} (Prowlarr)\"",
      "secretFieldTooltip": "Не принимает полный URL. Используйте только строки вроде uqcdi67cibkx3an8cmdm.",
      "proxy": "Прокси",
      "proxyDesc": "Установите прокси для скачивания .torrent файлов и фидов.",
      "selectProxy": "Выберите прокси",
      "selectProxyPlaceholder": "Выберите прокси",
      "chooseType": "Выберите тип"
    },
    "releaseProfile": {
      "title": "Профиль дубликатов",
      "added": "Профиль добавлен",
      "addFailed": "Не удалось добавить профиль",
      "deleted": "Профиль {{name}} удалён!",
      "fields": {
        "name": "Имя",
        "releaseName": "Имя релиза",
        "hash": "Хэш",
        "title": "Название",
        "subTitle": "Подзаголовок",
        "year": "Год",
        "month": "Месяц",
        "day": "День",
        "source": "Источник",
        "resolution": "Разрешение",
        "codec": "Кодек",
        "container": "Контейнер",
        "dynamicRange": "Динамический диапазон",
        "audio": "Аудио",
        "group": "Группа",
        "season": "Сезон",
        "episode": "Эпизод",
        "website": "Сайт/Сервис",
        "proper": "Proper",
        "repack": "Repack",
        "edition": "Издание",
        "hybrid": "Гибридная версия",
        "language": "Язык"
      },
      "descriptions": {
        "releaseName": "Полное имя релиза",
        "hash": "Нормализованный хэш имени релиза. Используйте с Именем релиза для точного совпадения",
        "title": "Спарсенное название",
        "subTitle": "Спарсенный подзаголовок (например, Имя эпизода)",
        "dailyReleases": "Для ежедневных релизов",
        "group": "Релиз-группа",
        "website": "Сервисы, такие как AMZN/HULU/NF",
        "dynamicRange": "Динамический диапазон (HDR, DV и т.д.)",
        "edition": "Издание и версия",
        "language": "Язык и регион"
      }
    },
    "cleanupJob": {
      "title": "Задача очистки",
      "created": "Задача очистки создана",
      "createFailed": "Не удалось создать задачу",
      "updated": "Задача обновлена",
      "updateFailed": "Не удалось обновить задачу",
      "deleted": "Задача {{name}} удалена",
      "enableDesc": "Включить эту задачу очистки",
      "namePlaceholder": "Еженедельная очистка",
      "schedule": "Расписание (Cron)",
      "schedulePlaceholder": "0 3 * * *",
      "scheduleHelp": "Выражение Cron. Примеры: '0 3 * * *' = ежедневно в 3 AM, '0 */6 * * *' = каждые 6 часов",
      "olderThan": "Старше чем",
      "olderThanPlaceholder": "30",
      "olderThanHelp": "Удалить релизы старше этого времени",
      "indexersOptional": "Индексаторы (Необязательно)",
      "statusesOptional": "Статусы (Необязательно)",
      "leaveEmptyIndexers": "Оставьте пустым, чтобы применить ко всем индексаторам",
      "leaveEmptyStatuses": "Оставьте пустым, чтобы применить ко всем статусам",
      "executionHistory": "История выполнений",
      "lastRun": "Последний запуск:",
      "status": "Статус:"
    }
  },
    "listScreens": {
    "common": {
      "enabled": "Включено",
      "name": "Имя",
      "type": "Тип",
      "edit": "Редактировать",
      "addNew": "Добавить",
      "unknownError": "Произошла неизвестная ошибка"
    },
    "downloadClients": {
      "title": "Клиенты загрузки",
      "description": "Управление клиентами загрузки.",
      "host": "Хост",
      "noItems": "Нет клиентов загрузки",
      "addNewItem": "Добавить нового клиента",
      "toggleSuccess": "Клиент {{name}} успешно {{state}}.",
      "enabledState": "включён",
      "disabledState": "отключён"
    },
    "notifications": {
      "title": "Уведомления",
      "description": "Настройка сервисов уведомлений и их глобальных триггеров.",
      "events": "События",
      "filters": "Фильтры",
      "noItems": "Нет уведомлений",
      "addNewItem": "Создать новое уведомление",
      "infoTitle": "Переопределения для фильтров:",
      "infoBody": "Вы можете переопределить эти глобальные настройки для конкретных фильтров на вкладке «Уведомления» каждого фильтра. Глобальные события необязательны — можно создать сервис без событий и настроить его только на уровне фильтра. Системные события (подключение/отключение IRC, обновления) всегда используют глобальные настройки.",
      "toggleSuccess": "Уведомление {{name}} успешно {{state}}.",
      "enabledState": "включено",
      "disabledState": "отключено"
    },
    "indexers": {
      "title": "Индексаторы",
      "description": "Настройки индексаторов для IRC, RSS, Newznab и Torznab.",
      "descriptionGeneric": "Обычные фиды RSS/Newznab/Torznab можно добавить здесь, выбрав один из <strong>Generic</strong> индексаторов.",
      "implementation": "Реализация",
      "noItems": "Нет индексаторов",
      "addNewItem": "Добавить новый индексатор",
      "updated": "Индексатор {{name}} успешно обновлён"
    },
    "proxies": {
      "title": "Прокси",
      "description": "Прокси, которые могут использоваться с индексаторами, фидами и IRC.",
      "noItems": "Нет прокси",
      "addNewItem": "Добавить новый прокси",
      "toggleSuccess": "Прокси {{name}} успешно {{state}}.",
      "toggleError": "Не удалось обновить статус прокси",
      "enabledState": "включён",
      "disabledState": "отключён"
    },
    "lists": {
      "title": "Списки",
      "description": "Списки могут автоматически обновлять ваши фильтры из arr-приложений и других источников.",
      "filters": "Фильтры",
      "noItems": "Нет списков",
      "addNewItem": "Добавить новый список",
      "toggleSuccess": "Список {{name}} успешно {{state}}.",
      "toggleError": "Не удалось обновить статус списка",
      "refreshSuccess": "Список {{name}} успешно получен.",
      "refreshError": "Не удалось обновить {{name}}. Ошибка: {{error}}",
      "deleted": "Список {{name}} удалён.",
      "removeTitle": "Удалить список: {{name}}",
      "removeText": "Вы уверены, что хотите удалить этот список? Это действие нельзя отменить.",
      "copyId": "Скопировать ID списка",
      "copyIdSuccess": "ID списка {{id}} скопирован в буфер обмена.",
      "refresh": "Обновить",
      "delete": "Удалить",
      "enabledState": "включён",
      "disabledState": "отключён"
    },
    "feeds": {
      "title": "Фиды",
      "description": "Управление фидами RSS, Newznab и Torznab.",
      "lastRun": "Последний запуск",
      "nextRun": "Следующий запуск",
      "noItems": "Нет фидов",
      "noItemsDesc": "Настройка через индексаторы",
      "toggleSuccess": "Фид {{name}} успешно {{state}}.",
      "enabledState": "включён",
      "disabledState": "отключён",
      "deleted": "Фид {{name}} удалён",
      "cacheCleared": "Кэш фида {{name}} очищен!",
      "forceRunSuccess": "Принудительный запуск фида {{name}} выполнен успешно.",
      "forceRunError": "Не удалось принудительно запустить {{name}}. Ошибка: {{error}}",
      "removeTitle": "Удалить фид: {{name}}",
      "removeText": "Вы уверены, что хотите удалить этот фид? Это действие нельзя отменить.",
      "removeCacheTitle": "Удалить кэш фида: {{name}}",
      "removeCacheText": "Вы уверены, что хотите удалить кэш фида? Это действие нельзя отменить.",
      "forceRunTitle": "Принудительно запустить фид: {{name}}",
      "forceRunText": "Вы уверены, что хотите принудительно запустить фид {{name}}? Соблюдение правил интервалов RSS критически важно, чтобы избежать потенциального бана по IP.",
      "toggle": "Вкл/Выкл",
      "forceRun": "Принудительный запуск",
      "viewLatestRun": "Посмотреть последний запуск",
      "clearCache": "Очистить кэш фида",
      "clearCacheTitle": "Вручную очистить весь кэш фида",
      "delete": "Удалить"
    }
  }
}
